/* tslint:disable */
/* eslint-disable */
/**
 * ELOfleet API Documentation
 * Backend of the ELOfleet fleet management system
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import * as runtime from '../runtime';
import {
    type ErrorResponse,
    ErrorResponseFromJSON,
    ErrorResponseToJSON,
} from '../models/ErrorResponse';
import {
    type PageInfo,
    PageInfoFromJSON,
    PageInfoToJSON,
} from '../models/PageInfo';
import {
    type Shift,
    ShiftFromJSON,
    ShiftToJSON,
} from '../models/Shift';
import {
    type ShiftCreate,
    ShiftCreateFromJSON,
    ShiftCreateToJSON,
} from '../models/ShiftCreate';
import {
    type ShiftSortKey,
    ShiftSortKeyFromJSON,
    ShiftSortKeyToJSON,
} from '../models/ShiftSortKey';
import {
    type ShiftUpdate,
    ShiftUpdateFromJSON,
    ShiftUpdateToJSON,
} from '../models/ShiftUpdate';
import {
    type SortDirection,
    SortDirectionFromJSON,
    SortDirectionToJSON,
} from '../models/SortDirection';

export interface ShiftsCreateShiftRequest {
    shiftCreate: ShiftCreate;
}

export interface ShiftsDeleteShiftRequest {
    shiftId: string;
}

export interface ShiftsListShiftsRequest {
    pageSize: number;
    search?: string | null;
    page?: number | null;
    sortDirection?: SortDirection;
    sortKey?: ShiftSortKey;
}

export interface ShiftsListShiftsMetadataRequest {
    pageSize: number;
    search?: string | null;
}

export interface ShiftsReadShiftRequest {
    shiftId: string;
}

export interface ShiftsUpdateShiftRequest {
    shiftId: string;
    shiftUpdate: ShiftUpdate;
}

export interface ShiftsValidateCreateShiftRequest {
    shiftCreate: ShiftCreate;
}

export interface ShiftsValidateUpdateShiftRequest {
    shiftId: string;
    shiftUpdate: ShiftUpdate;
}

/**
 * ShiftsApi - interface
 * 
 * @export
 * @interface ShiftsApiInterface
 */
export interface ShiftsApiInterface {
    /**
     * Creates request options for shiftsCreateShift without sending the request
     * @param {ShiftCreate} shiftCreate 
     * @throws {RequiredError}
     * @memberof ShiftsApiInterface
     */
    shiftsCreateShiftRequestOpts(requestParameters: ShiftsCreateShiftRequest): Promise<runtime.RequestOpts>;

    /**
     * Create a new shift.
     * @summary Create a shift
     * @param {ShiftCreate} shiftCreate 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ShiftsApiInterface
     */
    shiftsCreateShiftRaw(requestParameters: ShiftsCreateShiftRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Shift>>;

    /**
     * Create a new shift.
     * Create a shift
     */
    shiftsCreateShift(requestParameters: ShiftsCreateShiftRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Shift>;

    /**
     * Creates request options for shiftsDeleteShift without sending the request
     * @param {string} shiftId 
     * @throws {RequiredError}
     * @memberof ShiftsApiInterface
     */
    shiftsDeleteShiftRequestOpts(requestParameters: ShiftsDeleteShiftRequest): Promise<runtime.RequestOpts>;

    /**
     * Delete the shift with the given ID.
     * @summary Delete a shift
     * @param {string} shiftId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ShiftsApiInterface
     */
    shiftsDeleteShiftRaw(requestParameters: ShiftsDeleteShiftRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>>;

    /**
     * Delete the shift with the given ID.
     * Delete a shift
     */
    shiftsDeleteShift(requestParameters: ShiftsDeleteShiftRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void>;

    /**
     * Creates request options for shiftsListShifts without sending the request
     * @param {number} pageSize 
     * @param {string} [search] 
     * @param {number} [page] 
     * @param {SortDirection} [sortDirection] 
     * @param {ShiftSortKey} [sortKey] 
     * @throws {RequiredError}
     * @memberof ShiftsApiInterface
     */
    shiftsListShiftsRequestOpts(requestParameters: ShiftsListShiftsRequest): Promise<runtime.RequestOpts>;

    /**
     * Lists all the shifts present. If `search` is specified, return values similar to the `label` field, and `sortKey` will not have any effect: results will be sorted by similarity to the search term instead.
     * @summary List shifts
     * @param {number} pageSize 
     * @param {string} [search] 
     * @param {number} [page] 
     * @param {SortDirection} [sortDirection] 
     * @param {ShiftSortKey} [sortKey] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ShiftsApiInterface
     */
    shiftsListShiftsRaw(requestParameters: ShiftsListShiftsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<Shift>>>;

    /**
     * Lists all the shifts present. If `search` is specified, return values similar to the `label` field, and `sortKey` will not have any effect: results will be sorted by similarity to the search term instead.
     * List shifts
     */
    shiftsListShifts(requestParameters: ShiftsListShiftsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<Shift>>;

    /**
     * Creates request options for shiftsListShiftsMetadata without sending the request
     * @param {number} pageSize 
     * @param {string} [search] 
     * @throws {RequiredError}
     * @memberof ShiftsApiInterface
     */
    shiftsListShiftsMetadataRequestOpts(requestParameters: ShiftsListShiftsMetadataRequest): Promise<runtime.RequestOpts>;

    /**
     * Fetch information about the total amount of pages available.
     * @summary Shift listing metadata
     * @param {number} pageSize 
     * @param {string} [search] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ShiftsApiInterface
     */
    shiftsListShiftsMetadataRaw(requestParameters: ShiftsListShiftsMetadataRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PageInfo>>;

    /**
     * Fetch information about the total amount of pages available.
     * Shift listing metadata
     */
    shiftsListShiftsMetadata(requestParameters: ShiftsListShiftsMetadataRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PageInfo>;

    /**
     * Creates request options for shiftsReadShift without sending the request
     * @param {string} shiftId 
     * @throws {RequiredError}
     * @memberof ShiftsApiInterface
     */
    shiftsReadShiftRequestOpts(requestParameters: ShiftsReadShiftRequest): Promise<runtime.RequestOpts>;

    /**
     * Returns the shift specified by the given ID.
     * @summary Get a single shift
     * @param {string} shiftId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ShiftsApiInterface
     */
    shiftsReadShiftRaw(requestParameters: ShiftsReadShiftRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Shift>>;

    /**
     * Returns the shift specified by the given ID.
     * Get a single shift
     */
    shiftsReadShift(requestParameters: ShiftsReadShiftRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Shift>;

    /**
     * Creates request options for shiftsUpdateShift without sending the request
     * @param {string} shiftId 
     * @param {ShiftUpdate} shiftUpdate 
     * @throws {RequiredError}
     * @memberof ShiftsApiInterface
     */
    shiftsUpdateShiftRequestOpts(requestParameters: ShiftsUpdateShiftRequest): Promise<runtime.RequestOpts>;

    /**
     * Update the shift specified by the given ID.
     * @summary Update shift
     * @param {string} shiftId 
     * @param {ShiftUpdate} shiftUpdate 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ShiftsApiInterface
     */
    shiftsUpdateShiftRaw(requestParameters: ShiftsUpdateShiftRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Shift>>;

    /**
     * Update the shift specified by the given ID.
     * Update shift
     */
    shiftsUpdateShift(requestParameters: ShiftsUpdateShiftRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Shift>;

    /**
     * Creates request options for shiftsValidateCreateShift without sending the request
     * @param {ShiftCreate} shiftCreate 
     * @throws {RequiredError}
     * @memberof ShiftsApiInterface
     */
    shiftsValidateCreateShiftRequestOpts(requestParameters: ShiftsValidateCreateShiftRequest): Promise<runtime.RequestOpts>;

    /**
     * Validate data for a new shift without persisting it. Return an empty body if the data is valid. Return validation errors if it is invalid.
     * @summary Validate a shift
     * @param {ShiftCreate} shiftCreate 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ShiftsApiInterface
     */
    shiftsValidateCreateShiftRaw(requestParameters: ShiftsValidateCreateShiftRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>>;

    /**
     * Validate data for a new shift without persisting it. Return an empty body if the data is valid. Return validation errors if it is invalid.
     * Validate a shift
     */
    shiftsValidateCreateShift(requestParameters: ShiftsValidateCreateShiftRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void>;

    /**
     * Creates request options for shiftsValidateUpdateShift without sending the request
     * @param {string} shiftId 
     * @param {ShiftUpdate} shiftUpdate 
     * @throws {RequiredError}
     * @memberof ShiftsApiInterface
     */
    shiftsValidateUpdateShiftRequestOpts(requestParameters: ShiftsValidateUpdateShiftRequest): Promise<runtime.RequestOpts>;

    /**
     * Validate data for updating the given shift, without persisting it. Return an empty body if the data is valid. Return validation errors if it is invalid.
     * @summary Validate shift update
     * @param {string} shiftId 
     * @param {ShiftUpdate} shiftUpdate 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ShiftsApiInterface
     */
    shiftsValidateUpdateShiftRaw(requestParameters: ShiftsValidateUpdateShiftRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>>;

    /**
     * Validate data for updating the given shift, without persisting it. Return an empty body if the data is valid. Return validation errors if it is invalid.
     * Validate shift update
     */
    shiftsValidateUpdateShift(requestParameters: ShiftsValidateUpdateShiftRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void>;

}

/**
 * 
 */
export class ShiftsApi extends runtime.BaseAPI implements ShiftsApiInterface {

    /**
     * Creates request options for shiftsCreateShift without sending the request
     */
    async shiftsCreateShiftRequestOpts(requestParameters: ShiftsCreateShiftRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['shiftCreate'] == null) {
            throw new runtime.RequiredError(
                'shiftCreate',
                'Required parameter "shiftCreate" was null or undefined when calling shiftsCreateShift().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("HttpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/shifts/`;

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ShiftCreateToJSON(requestParameters['shiftCreate']),
        };
    }

    /**
     * Create a new shift.
     * Create a shift
     */
    async shiftsCreateShiftRaw(requestParameters: ShiftsCreateShiftRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Shift>> {
        const requestOptions = await this.shiftsCreateShiftRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ShiftFromJSON(jsonValue));
    }

    /**
     * Create a new shift.
     * Create a shift
     */
    async shiftsCreateShift(requestParameters: ShiftsCreateShiftRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Shift> {
        const response = await this.shiftsCreateShiftRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for shiftsDeleteShift without sending the request
     */
    async shiftsDeleteShiftRequestOpts(requestParameters: ShiftsDeleteShiftRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['shiftId'] == null) {
            throw new runtime.RequiredError(
                'shiftId',
                'Required parameter "shiftId" was null or undefined when calling shiftsDeleteShift().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("HttpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/shifts/{shift_id}`;
        urlPath = urlPath.replace('{shift_id}', encodeURIComponent(String(requestParameters['shiftId'])));

        return {
            path: urlPath,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Delete the shift with the given ID.
     * Delete a shift
     */
    async shiftsDeleteShiftRaw(requestParameters: ShiftsDeleteShiftRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const requestOptions = await this.shiftsDeleteShiftRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Delete the shift with the given ID.
     * Delete a shift
     */
    async shiftsDeleteShift(requestParameters: ShiftsDeleteShiftRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.shiftsDeleteShiftRaw(requestParameters, initOverrides);
    }

    /**
     * Creates request options for shiftsListShifts without sending the request
     */
    async shiftsListShiftsRequestOpts(requestParameters: ShiftsListShiftsRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['pageSize'] == null) {
            throw new runtime.RequiredError(
                'pageSize',
                'Required parameter "pageSize" was null or undefined when calling shiftsListShifts().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['search'] != null) {
            queryParameters['search'] = requestParameters['search'];
        }

        if (requestParameters['page'] != null) {
            queryParameters['page'] = requestParameters['page'];
        }

        if (requestParameters['pageSize'] != null) {
            queryParameters['page_size'] = requestParameters['pageSize'];
        }

        if (requestParameters['sortDirection'] != null) {
            queryParameters['sort_direction'] = requestParameters['sortDirection'];
        }

        if (requestParameters['sortKey'] != null) {
            queryParameters['sort_key'] = requestParameters['sortKey'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("HttpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/shifts/`;

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Lists all the shifts present. If `search` is specified, return values similar to the `label` field, and `sortKey` will not have any effect: results will be sorted by similarity to the search term instead.
     * List shifts
     */
    async shiftsListShiftsRaw(requestParameters: ShiftsListShiftsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<Shift>>> {
        const requestOptions = await this.shiftsListShiftsRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(ShiftFromJSON));
    }

    /**
     * Lists all the shifts present. If `search` is specified, return values similar to the `label` field, and `sortKey` will not have any effect: results will be sorted by similarity to the search term instead.
     * List shifts
     */
    async shiftsListShifts(requestParameters: ShiftsListShiftsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<Shift>> {
        const response = await this.shiftsListShiftsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for shiftsListShiftsMetadata without sending the request
     */
    async shiftsListShiftsMetadataRequestOpts(requestParameters: ShiftsListShiftsMetadataRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['pageSize'] == null) {
            throw new runtime.RequiredError(
                'pageSize',
                'Required parameter "pageSize" was null or undefined when calling shiftsListShiftsMetadata().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['search'] != null) {
            queryParameters['search'] = requestParameters['search'];
        }

        if (requestParameters['pageSize'] != null) {
            queryParameters['page_size'] = requestParameters['pageSize'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("HttpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/shifts/meta`;

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Fetch information about the total amount of pages available.
     * Shift listing metadata
     */
    async shiftsListShiftsMetadataRaw(requestParameters: ShiftsListShiftsMetadataRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PageInfo>> {
        const requestOptions = await this.shiftsListShiftsMetadataRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PageInfoFromJSON(jsonValue));
    }

    /**
     * Fetch information about the total amount of pages available.
     * Shift listing metadata
     */
    async shiftsListShiftsMetadata(requestParameters: ShiftsListShiftsMetadataRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PageInfo> {
        const response = await this.shiftsListShiftsMetadataRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for shiftsReadShift without sending the request
     */
    async shiftsReadShiftRequestOpts(requestParameters: ShiftsReadShiftRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['shiftId'] == null) {
            throw new runtime.RequiredError(
                'shiftId',
                'Required parameter "shiftId" was null or undefined when calling shiftsReadShift().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("HttpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/shifts/{shift_id}`;
        urlPath = urlPath.replace('{shift_id}', encodeURIComponent(String(requestParameters['shiftId'])));

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Returns the shift specified by the given ID.
     * Get a single shift
     */
    async shiftsReadShiftRaw(requestParameters: ShiftsReadShiftRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Shift>> {
        const requestOptions = await this.shiftsReadShiftRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ShiftFromJSON(jsonValue));
    }

    /**
     * Returns the shift specified by the given ID.
     * Get a single shift
     */
    async shiftsReadShift(requestParameters: ShiftsReadShiftRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Shift> {
        const response = await this.shiftsReadShiftRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for shiftsUpdateShift without sending the request
     */
    async shiftsUpdateShiftRequestOpts(requestParameters: ShiftsUpdateShiftRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['shiftId'] == null) {
            throw new runtime.RequiredError(
                'shiftId',
                'Required parameter "shiftId" was null or undefined when calling shiftsUpdateShift().'
            );
        }

        if (requestParameters['shiftUpdate'] == null) {
            throw new runtime.RequiredError(
                'shiftUpdate',
                'Required parameter "shiftUpdate" was null or undefined when calling shiftsUpdateShift().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("HttpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/shifts/{shift_id}`;
        urlPath = urlPath.replace('{shift_id}', encodeURIComponent(String(requestParameters['shiftId'])));

        return {
            path: urlPath,
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: ShiftUpdateToJSON(requestParameters['shiftUpdate']),
        };
    }

    /**
     * Update the shift specified by the given ID.
     * Update shift
     */
    async shiftsUpdateShiftRaw(requestParameters: ShiftsUpdateShiftRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Shift>> {
        const requestOptions = await this.shiftsUpdateShiftRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ShiftFromJSON(jsonValue));
    }

    /**
     * Update the shift specified by the given ID.
     * Update shift
     */
    async shiftsUpdateShift(requestParameters: ShiftsUpdateShiftRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Shift> {
        const response = await this.shiftsUpdateShiftRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for shiftsValidateCreateShift without sending the request
     */
    async shiftsValidateCreateShiftRequestOpts(requestParameters: ShiftsValidateCreateShiftRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['shiftCreate'] == null) {
            throw new runtime.RequiredError(
                'shiftCreate',
                'Required parameter "shiftCreate" was null or undefined when calling shiftsValidateCreateShift().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("HttpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/shifts/validate`;

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ShiftCreateToJSON(requestParameters['shiftCreate']),
        };
    }

    /**
     * Validate data for a new shift without persisting it. Return an empty body if the data is valid. Return validation errors if it is invalid.
     * Validate a shift
     */
    async shiftsValidateCreateShiftRaw(requestParameters: ShiftsValidateCreateShiftRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const requestOptions = await this.shiftsValidateCreateShiftRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Validate data for a new shift without persisting it. Return an empty body if the data is valid. Return validation errors if it is invalid.
     * Validate a shift
     */
    async shiftsValidateCreateShift(requestParameters: ShiftsValidateCreateShiftRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.shiftsValidateCreateShiftRaw(requestParameters, initOverrides);
    }

    /**
     * Creates request options for shiftsValidateUpdateShift without sending the request
     */
    async shiftsValidateUpdateShiftRequestOpts(requestParameters: ShiftsValidateUpdateShiftRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['shiftId'] == null) {
            throw new runtime.RequiredError(
                'shiftId',
                'Required parameter "shiftId" was null or undefined when calling shiftsValidateUpdateShift().'
            );
        }

        if (requestParameters['shiftUpdate'] == null) {
            throw new runtime.RequiredError(
                'shiftUpdate',
                'Required parameter "shiftUpdate" was null or undefined when calling shiftsValidateUpdateShift().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("HttpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/shifts/{shift_id}/validate`;
        urlPath = urlPath.replace('{shift_id}', encodeURIComponent(String(requestParameters['shiftId'])));

        return {
            path: urlPath,
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: ShiftUpdateToJSON(requestParameters['shiftUpdate']),
        };
    }

    /**
     * Validate data for updating the given shift, without persisting it. Return an empty body if the data is valid. Return validation errors if it is invalid.
     * Validate shift update
     */
    async shiftsValidateUpdateShiftRaw(requestParameters: ShiftsValidateUpdateShiftRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const requestOptions = await this.shiftsValidateUpdateShiftRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Validate data for updating the given shift, without persisting it. Return an empty body if the data is valid. Return validation errors if it is invalid.
     * Validate shift update
     */
    async shiftsValidateUpdateShift(requestParameters: ShiftsValidateUpdateShiftRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.shiftsValidateUpdateShiftRaw(requestParameters, initOverrides);
    }

}
